import React from 'react';
import {
  Box,
  Typography,
  LinearProgress,
  useTheme,
  Paper,
  Grid
} from '@mui/material';

const InventoryProgress = ({ data }) => {
  const theme = useTheme();

  if (!data) return <Typography>Loading...</Typography>;

  const { total, matched, unmatched, percent_matched } = data;

  const getColor = (value) => {
    if (value >= 75) return theme.palette.success.main;
    if (value >= 50) return theme.palette.warning.main;
    return theme.palette.error.main;
  };

  return (
    <Paper sx={{ p: 4,  mx: 'auto', mt: 3 }} elevation={3}>
      <Typography variant="h6" gutterBottom align="center">
        Inventur Abdeckung (Zeitraum)
      </Typography>

      <Box sx={{ mt: 2 }}>
        <LinearProgress
          variant="determinate"
          value={percent_matched}
          sx={{
            height: 20,
            borderRadius: 10,
            backgroundColor: theme.palette.grey[300],
            '& .MuiLinearProgress-bar': {
              backgroundColor: getColor(percent_matched)
            }
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="caption" color="text.secondary">0%</Typography>
          <Typography variant="caption" color="text.secondary">100%</Typography>
        </Box>
      </Box>

      <Grid container spacing={2} sx={{ mt: 4 }} justifyContent="center">
        <Grid item xs={12} sm={4}>
          <Typography align="center" variant="body2" color="text.secondary">Total</Typography>
          <Typography align="center" variant="h6">{total}</Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography align="center" variant="body2" color="success.main">Erledigt</Typography>
          <Typography align="center" variant="h6" color="success.main">{matched}</Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography align="center" variant="body2" color="error.main">Offen</Typography>
          <Typography align="center" variant="h6" color="error.main">{unmatched}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default InventoryProgress;
